import * as React from "react";
import * as _ from "lodash";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import * as InfiniteScroll from 'react-infinite-scroller';
import { Row, Col } from "reactstrap";
import SidebarContainer from "src/modules/Routing/Sidebar/SidebarContainer";
import MapClusters, { IMapClusters, MapClustersTypes } from "src/share/components/Maps/MapClusters/MapClusters";
import { IReduxState } from "src/reduxTypes";
import { GeoSearchService } from "src/share/services/geoSearch";
import { IGeoSearchViewState, initialGeoSearchViewState, IGeoSearchProps } from "src/share/types/geoSearch";
import { GeoSearchCard } from "./components/GeoSearchCard";
import AgencyFilter from "src/share/components/AgencyFilter/AgencyFilter";
import { FetchType } from "src/modules/Case/View/caseView.type";
import MonthlyFilter, { IMonthOption } from "src/share/components/MonthlyFilter/MonthlyFilter";
import { GeoSearchCardLoader } from "src/share/components/ChartLoader/GeoSearchCardLoader";
import { getOptions } from "src/share/utils/utils";
import './geoSearchView.css';
import { RoutesModules } from "src/modules/Routing/types";

export class GeoSearchView extends React.Component<IGeoSearchProps, IGeoSearchViewState> {
  constructor(props: IGeoSearchProps) {
    super(props);
    const options = getOptions();
    this.state = {
      loading: true,
      page: 0,
      pages: 0,
      size: 10,
      fetchingData: false,
      searches: {
        results: [],
        total: 0
      },
      options,
      selected: options[0]
    }
  }
  public componentDidMount() {
    this.loadData()
  }
  public async loadData(fetch = FetchType.Initial) {
    try {
      const isInitialOrFiltering = fetch === FetchType.Initial || fetch === FetchType.Filter;
      await new Promise(res => {
        this.setState(state => ({
          ...isInitialOrFiltering ? _.cloneDeep(initialGeoSearchViewState) : state,
          fetchingData: true
        }), res)
      });
      const { total, results } = await this.fetch();
      this.setState((state) => ({
        searches: {
          results: [...state.searches.results, ...results],
          total
        },
        loading: false,
        fetchingData: false,
        pages: total / 8
      }));
    } catch (error) {
      toastr.error('Error', 'There was a problem connecting to the server')
      this.setState({ fetchingData: false, loading: false })
    }
  }
  public async fetch() {
    const { searches, filterByAgency, selected } = this.state;
    const last = searches.results.length;
    return GeoSearchService.get({
      ...filterByAgency ? { filterByAgency } : {},
      ...selected ? { range: { lte: selected.lte, gte: selected.gte } } : {},
      page: last / 8,
      size: 8
    });
  }
  public loadMore = (e) => {
    if (this.state.searches.results.length < this.state.searches.total && e >= 1 && !this.state.fetchingData) {
      this.loadData(FetchType.Infinite);
    }
  }
  public filterByAgency = (agencyCode: string) => {
    this.setState({ filterByAgency: agencyCode }, () => this.loadData(FetchType.Filter))
  }
  public changeMonth = async (selected: IMonthOption) => {
    this.setState({ selected }, () => this.loadData())
  }
  public getClusters(): IMapClusters[] {
    return this.state.searches.results.map(search =>
      ({
        id: search.id,
        lat: search.center.lat,
        lng: search.center.lng,
        radius: search.radius,
        caseId: search.caseId,
        date: search.date,
        manual: search.manual,
        searchName: search.searchName,
        person: {
          personId: search.person && search.personType === 'child' && search.person.childId ?
            search.person.childId : search.person && search.person.abductorId ? search.person.abductorId : '',
          fullName: search.person && search.person.fullName ? search.person.fullName : '',
        }
      })
    );
  }
  public render() {
    const { searches, loading } = this.state;
    const clusters = this.getClusters();
    return (
      <div className="geo-search-view">
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMore}
          hasMore={this.state.page <= this.state.pages}
          useWindow={false}
        >
          <Row>
            <Col className={"col-lg-7 col-md-7 col-sm-7 d-none d-sm-block d-xs-none"}>
              <div className={"mapContainer"}>
                <h3 className="title">Place date time radius search</h3>
                <AgencyFilter changeAgency={this.filterByAgency} showOnlyAdmin={true} loading={loading} />
                <MonthlyFilter changeSelected={this.changeMonth} options={this.state.options as IMonthOption[]} selected={this.state.selected as IMonthOption} />
                <MapClusters
                  clusters={clusters}
                  history={this.props.history}
                  mapType={MapClustersTypes.GEOSEARCH}
                />
              </div>
            </Col>
            <Col className="alertsContainer col-lg-5 col-md-5 col-sm-5 col-xs-12">
              <div className={`alerts${searches && searches.results.length > 0 ? '' : ' empty'}`}>
                {
                  searches && searches.results.length > 0 ?
                    searches.results.map((search) =>
                      <GeoSearchCard
                        key={search.id}
                        id={search.id}
                        caseId={search.caseId}
                        date={search.date}
                        radius={search.radius}
                        title={search.manual ? search.searchName || "Manual Search" : search.person.fullName || ""}
                        editable={search.manual}
                        history={this.props.history} />)
                    :
                    !this.state.loading ?
                      <h4 className="no-results">No searches issued</h4> : null
                }
                {
                  (this.state.loading || this.state.fetchingData) &&
                  Array.apply(null, { length: 5 }).map((data, index) => <GeoSearchCardLoader key={index} />)
                }
              </div>
            </Col>
          </Row>
        </InfiniteScroll>
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default SidebarContainer(RoutesModules.GEOSEARCH)(connect(mapStateToProps)(GeoSearchView));



// WEBPACK FOOTER //
// ./src/modules/GeoSearch/View/GeoSearchView.tsx